import { Price } from "@omni/components/components/Price/price";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { TieredPrice } from "@omni/types/api/product/bff/shared/tieredPrice.model";
import { cn } from "@omni/utils/styles";

type TieredPriceComponentProps = {
    price: TieredPrice;
};

const TieredPriceComponent = ({ price }: TieredPriceComponentProps) => {
    const { t } = useGranite();

    return (
        <div
            className={cn(
                "tw:border-x-3 tw:border-b-3 tw:border-primary tw:uppercase tw:text-primary tw:flex tw:items-center tw:last-of-type:rounded-b-xl"
            )}
        >
            <div className={cn("tw:p-4 tw:w-1/2")}>
                <span className={cn("tw:font-gravity tw:font-bold tw:text-lg")}>
                    {t(
                        "product.eCommerce.price.tieredPrice.quantity",
                        price.quantity
                    )}
                </span>
            </div>
            <div className={cn("tw:p-4 tw:flex tw:items-end tw:w-1/2")}>
                <Price
                    price={price.price}
                    size={"lg"}
                >
                    <Price.Main />
                </Price>
                <span className={cn("tw:font-gravity tw:italic")}>
                    {t("product.eCommerce.price.tieredPrice.unit")}
                </span>
            </div>
        </div>
    );
};

export { TieredPriceComponent };
